<script setup lang="ts">
import { ref } from 'vue';

const markets = ref([
  { id: 'result', label: 'Result', selected: true },
  { id: 'goals', label: 'Goals', selected: false },
  { id: 'corners', label: 'Corners', selected: false },
  { id: 'btts', label: 'Both Teams To Score', selected: false },
  { id: 'player', label: 'Player To Score', selected: false }
]);

const toggleMarket = (index: number) => {
  const market = markets.value[index];
  if (market) {
    market.selected = !market.selected;
  }
};
</script>

<template>
  <div class="add-market-parity-mock dark">
    <div class="add-more-header dark">
      <h2 class="centered-title">Add market</h2>
      <p class="centered-desc">Choose a market to add to this event</p>
    </div>
    <div class="add-market-body dark">
      <div class="market-list-card dark">
        <ul class="market-list-options border border-zinc-800 rounded-xl overflow-hidden">
          <li 
            v-for="(m, idx) in markets" 
            :key="m.id" 
            class="list-row" 
            :class="{ active: m.selected }"
            @click="toggleMarket(idx)"
          >
            {{ m.label }}
          </li>
        </ul>
      </div>
    </div>
    <div class="add-more-footer dark">
      <button class="footer-btn-parity red" :disabled="!markets.some(m => m.selected)">
        Add Market
      </button>
    </div>
  </div>
</template>

<style scoped>
.add-market-parity-mock { height: 100%; min-height: 600px; background: #09090b; display: flex; flex-direction: column; }
.add-more-header { padding: 24px; border-bottom: 1px solid rgba(255,255,255,0.05); display: flex; flex-direction: column; align-items: center; justify-content: center; position: relative; }
.centered-title { font-size: 1.2rem; font-weight: 900; color: #fff; text-align: center; }
.centered-desc { font-size: 0.85rem; color: #71717a; text-align: center; margin-top: 4px; }

.add-market-body { padding: 20px; flex-grow: 1; display: flex; justify-content: center; }
.market-list-card { background: #000; width: 100%; max-width: 440px; height: fit-content; color: #fff; }
.market-list-options { display: flex; flex-direction: column; list-style: none; padding: 0; margin: 0; background: #000; }
.list-row { padding: 14px 20px; font-weight: 800; cursor: pointer; transition: background 0.2s, color 0.2s; border-bottom: none; }
.list-row:last-child { border-bottom: none; }
.list-row.active { background: #e21b0d; color: #fff; }
.list-row:not(.active):hover { background: #18181b; }

.add-more-footer { padding: 32px; border-top: 1px solid rgba(255,255,255,0.05); display: flex; justify-content: center; }
.footer-btn-parity { width: 100%; max-width: 500px; height: 56px; border-radius: 16px; border: none; font-weight: 900; font-size: 1.1rem; cursor: pointer; background: #e21b0d; color: #fff; box-shadow: 0 8px 24px rgba(226, 27, 13, 0.3); transition: opacity 0.2s, background-color 0.2s; }
.footer-btn-parity:disabled { opacity: 0.5; cursor: not-allowed; background-color: #3f3f46; box-shadow: none; }

@media (max-width: 768px) {
  .centered-title { position: static; transform: none; font-size: 1.5rem; margin-top: 8px; }
}

.animate-in { animation: fadeInUp 0.4s ease forwards; }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>